import http_request from './http_request'
import config from 'config'
import sendFormPost from 'helpers/http_request/postForm'

function saveCanvas(presentationUid, type, uid, ltiForwardUrl) {
	return http_request.post(config.services + 'webCanvas/save')
		.send({
			uid,
			presentationUid,
			type,
			ltiForwardUrl,
		})
}

function sendLtiForm(url, params) {
	return sendFormPost(url, params, 'post')
}

function associateUser(ltiUid, ltiToken) {
	return http_request.post(`${config.services}webCanvas/associateUser`)
		.send({
			uid: ltiUid,
			ltiToken,
		})
}

export default {
	saveCanvas,
	sendLtiForm,
	associateUser,
}
